/* ════════════ PIXEL PETALS ════════════
   Falling cherry-blossom petals, pixel-art style — the sakura page's
   counterpart to the home page starfield. */

import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function petals(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#petals")!;
  const ctx = c.getContext("2d")!;
  const colors = ["#ff9ec7", "#ffb7d5", "#ff2e88", "#e8d9e4"];

  type Petal = {
    x: number;
    y: number;
    s: number; // size in px
    vy: number; // fall speed
    sway: number; // sway amplitude
    phase: number; // sway phase
    col: string;
  };
  let petals: Petal[] = [];

  const make = (y?: number): Petal => ({
    x: Math.random() * c.width,
    y: y ?? -6,
    s: Math.random() > 0.8 ? 3 : 2,
    vy: 0.25 + Math.random() * 0.6,
    sway: 0.4 + Math.random() * 1.2,
    phase: Math.random() * Math.PI * 2,
    col: colors[(Math.random() * colors.length) | 0]!,
  });

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(90, Math.floor((c.width * c.height) / 22000));
    petals = Array.from({ length: count }, () => make(Math.random() * c.height));
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const p of petals) {
      ctx.globalAlpha = 0.45 + 0.4 * Math.sin(p.phase);
      ctx.fillStyle = p.col;
      // tiny pixel petal: offset pair of squares reads as a falling petal
      ctx.fillRect(p.x | 0, p.y | 0, p.s, p.s);
      ctx.fillRect((p.x + p.s) | 0, (p.y - p.s) | 0, p.s, p.s);
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  let t = 0;
  const tick = () => {
    if (signal.aborted) return;
    t += 0.016;
    for (const p of petals) {
      p.y += p.vy;
      p.x += Math.sin(t * 0.8 + p.phase) * p.sway * 0.3;
      p.phase += 0.01;
      if (p.y > c.height + 6) Object.assign(p, make());
      if (p.x < -6) p.x = c.width + 4;
      if (p.x > c.width + 6) p.x = -4;
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage(petals);
